import React from "react";
import HeroSection from "./Home/HeroSection";
import Welcomesection from "./Home/Welcomesection";
import CountDownSection from "./Home/CountDownSection";
import VenueSection from "./VenuePage/VenueSection";
import OrganizingComitteeSection from "./Home/OrganizingComitteeSection";
import NotificationBanner from "./Notifications/Notifications";

const Home = () => {
  return (
    <div className="ppb_wrapper">
      <HeroSection />
      <Welcomesection />
      <CountDownSection />
      <OrganizingComitteeSection />
      <VenueSection />
    </div>
  );
};

export default Home;
